import { GLOBAL_COUNTRY_ISO, GLOBAL_COUNTRY_NAME } from "@stadium/helpers/country/constants";

export const CANADA_ISO = "CA";
export const US_ISO = "US";
export const GLOBAL_ISO = "GL";
export const BRAZIL_ISO = "BR";

export const NON_INTERNATIONAL_COUNTRIES_ISO = [CANADA_ISO, US_ISO];

export const US_COUNTRY = Object.freeze({
  name: "United States",
  iso: US_ISO,
  label: "US",
});

export const GLOBAL_COUNTRY = Object.freeze({
  name: GLOBAL_COUNTRY_NAME,
  iso: GLOBAL_COUNTRY_ISO,
  label: "global",
  id: "global",
});

export const GDPR_COUNTRIES_ISO = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "GB",
];
